import defineComponent from 'flight';

function MegaCategories() {

    let linkToggleClass = 'mega-categories-list-heading-active';
    // var listlinkToggleClass = 'mega-categories-list-active';
    let showCategoryTimer;

    this.defaultAttrs({
        linkSelector: '[data-start-page-mega-categories-link]',
        listSelector: '[data-start-page-mega-categories-list]',
        listItemSelector: '[data-start-page-mega-categories-list-item]',
        itemSelector: '[data-start-page-mega-categories-list-item] a'
    });

    /* Touch devices */
    this._toggleMegaCategory = function (evt) {
        let target = $(evt.target);
        if (target.closest('a').length) {
            return;
        }

        if (target.closest(this.attr.listItemSelector).length) {
            return;
        }

        evt.preventDefault();
        evt.stopPropagation();

        let el = target.closest(this.attr.linkSelector);

        if (el.hasClass(linkToggleClass)) {
            el.removeClass(linkToggleClass);
        } else {
            this._closeCategories();
            el.addClass(linkToggleClass);
            this.trigger(document, 'ui:mega-categories-on-show');
        }
    };

    this._showCategory = function (evt) {
        let link = $(evt.currentTarget);
        if (link.hasClass(linkToggleClass)) { return; }

        let categoryOpen = this._isCategoriesOpen();

        let show = function () {
            link.addClass(linkToggleClass);
        }.bind(this);

        link.one('mouseleave', function () {
            clearTimeout(showCategoryTimer);
        }.bind(this));

        if (categoryOpen === true) {
            this._closeCategories();
            show();
        } else {
            showCategoryTimer = setTimeout(function () {
                this.trigger(document, 'ui:mega-categories-on-show');
                show();
            }.bind(this), 200);
        }
    };

    this._isCategoriesOpen = function () {
        return this.select('linkSelector').hasClass(linkToggleClass);
    };

    this._closeCategories = function () {
        this.select('linkSelector').removeClass(linkToggleClass);
    };

    this._trackClickEvent = function (evt) {
        let target = $(evt.target);
        this.trigger(document, 'analytics:track-event', {
            category: 'StartPage',
            action: 'Navigation - mega categories',
            label: target.text().trim()
        });
    };

    this._onTeardown = function () {
        // Remove non-flight bindings
        this.select('linkSelector').off('mouseenter', this._showCategory.bind(this));
        this.select('listSelector').off('mouseleave', this._closeCategories.bind(this));
    };

    this.after('initialize', function () {
        this.select('linkSelector').on('mouseenter', this._showCategory.bind(this));
        this.select('listSelector').on('mouseleave', this._closeCategories.bind(this));

        this.on('click', {
            linkSelector: this._toggleMegaCategory,
            itemSelector: this._trackClickEvent
        });

        this.on(document, 'ui:site-header-my-tradera-dropdown-on-show', this._closeCategories);
        this.on(document, 'ui:teardown', this._onTeardown);
    });
}

export default defineComponent.component(MegaCategories);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/mega-categories.js